import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLangChecker } from '@common/utils/i18n';
export const GenericLabel = ({ label, className }) => {
    return (React.createElement("span", { ref: useLangChecker, className: classNames('product-label', className) }, label.trim()));
};
const ProductLabels = (props) => {
    const { product, type } = props;
    let { t } = useTranslation();
    const [labels, setLabels] = useState([]);
    useEffect(() => {
        let _labels = [];
        if (product) {
            _labels = [
                (product.isBoutiqueExclusive || (type !== 'tile' && product.isBoutiqueExclusivePDP)) && t('label.botiqueexclusive'),
                product.isPreview && t('label.ispreview'),
                (!product.isBoutiqueExclusive || !product.isBoutiqueExclusivePDP) && product.isComingSoon === 2 && t('label.comingsoon'),
                // product.availability?.isOutOfStock && product.isComingSoon && !product.isBoutiqueExclusive && t('label.outofstock'),
                product.isLimitedEdition && t('label.limitededition'),
                product.isOnlineExclusive && t('label.onlineexclusive'),
                product.isNew && t('label.isnew'),
                // product.unlock && t('tile.membersonly'),
            ];
            _labels = _labels.filter((string) => !!string);
            if (props.limit) {
                _labels.splice(1, props.limit);
            }
        }
        setLabels(_labels);
    }, [product]);
    if ((labels === null || labels === void 0 ? void 0 : labels.length) < 1)
        return React.createElement(React.Fragment, null);
    return (React.createElement("div", { className: "product-labels font__subtitle" }, labels.map((label, i) => (React.createElement(GenericLabel, { key: i, label: label })))));
};
export default ProductLabels;
